<template>
  <ag-grid-vue
      style="width: 100%; height: 60vh; min-height: 200px"
      :class="{'ag-theme-balham' : !this.$vuetify.theme.dark,
              'ag-theme-balham-dark' : this.$vuetify.theme.dark }"
      :gridOptions="gridOptions"

      :enableColResize="true"
      :enableSorting="true"

      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :frameworkComponents="gridOptions.frameworkComponents"

      :context="context"
      :rowData="assignList"

      rowSelection="multiple"
      @grid-ready="onGridReady"
      @cellClicked="onClickRow"
      @cell-value-changed="onCellValueChanged"
      @selection-changed="onSelectionChanged"
  />
</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import {agGridDatePicker} from "@/utils/agGrid_util";
import { btnRendererSentFee, btnRendererComplete } from "@/components/Grid/GridAssignButtonRenderer";
import apiManager from "@/api/modules/api-manager";
import {mapGetters} from "vuex";
import { cellRendererAssignStatus } from "@/components/Grid/GridCellRenderer";
export default {
  name: 'GridAssign',
  components: {AgGridVue,
    btnRendererComplete,
    btnRendererSentFee,
    cellRendererAssignStatus
  },
  props: {
    assignList: Array
  },
  data() {
    return {
      listLoading: true,
      selectedRow: {},
      selectedTeacher: {},
      searchTeacherDialog: false,
      wageSum: 0,
      context: '',
      gridApi: [],
      columnApi: null,
      defaultColDef :{
        sortable: true,
        flex: 8,
        wrapText: true,
        filter: true,
        resizable: true,
        draggable: true
      },
      gridOptions : {
        animateRows: false,
        frameworkComponents: {},
        rowSelection: 'multiple',
        enableRangeSelection: true,
        suppressCopyRowsToClipboard: true
      },
      columnDefs: [
        // {flex: 0.5, colId: 'id', valueGetter: "node.rowIndex + 1"},
        {flex: 1, headerName: 'Id', field: 'assignId'},
        {flex: 1.2, headerName: 'Start Date',    field: 'startDate'  , editable: true, cellEditor: agGridDatePicker },
        {flex: 1.2, headerName: 'End Date',      field: 'endDate' , editable: true, cellEditor: agGridDatePicker},
        {flex: 1, colId: 'classStartTime', headerName: 'Start Time',     field: 'classStartTime'},
        {flex: 1, colId: 'courseName', headerName: 'Course',        field: 'courseName', cellStyle: { color: 'orange' }},
        {flex: 1, colId: 'studentKorName', headerName: 'Student Kor',       field: 'studentName'},
        {flex: 1, colId: 'studentEngName', headerName: 'Student',              field: 'studentEngName', editable: true},
        // {flex: 1, colId: 'skypeId', headerName: 'App Id',              field: 'skypeId', editable: true},
        {flex: 1, colId: 'teacherName', headerName: 'Teacher',             field: 'teacherName' },
        // {flex: 1, colId: 'assignCount', headerName: 'Count Assigned ',       field: 'assignCount' },
        {flex: 1, colId: 'countCalculated', headerName: 'Count Calculated ',       field: 'countCalculated' },
        {flex: 1, colId: 'wage', headerName: 'Wage',       field: 'wage', valueFormatter: params => params.data.wage.toFixed(0)},
        {flex: 1.2, colId: 'sendFee', headerName: 'Send Fee', field: 'sendFee' ,cellRendererFramework: "btnRendererSentFee"},
        {flex: 1, colId: 'assignStatus', headerName: 'Status', field: 'assignStatus', cellRenderer: "cellRendererAssignStatus"},
        // {flex: 1, colId: 'complete' , headerName: 'Complete', field: 'complete' , cellRendererFramework: "btnRendererComplete"},
        {flex: 1,  colId: 'mention', headerName: 'Mention', field: 'assignMention', editable: true, cellEditor: 'agLargeTextCellEditor', cellEditorPopup: true, cellStyle: {'background-color': 'grey'} },
      ]
    }
  },
  computed: {
    ...mapGetters(['app', 'user','isOwner', 'isManager', 'isMobile']),
  },
  watch: {
  },
  created() {
    this.hideActionColumn()
  },
  async beforeMount() {
    this.context = {viewManagerAssign: this};
  },
  mounted() {
    window.addEventListener('resize', this.hideActionColumn);
  },
  methods: {
    onGridReady(params){
      params.api.setHeaderHeight(60);
      this.columnApi = params.columnApi;
      this.gridApi = params.api;
      this.$emit('onGridReady', this.gridApi, this.gridOptions)
      this.hideActionColumn()
    },
    onClickRow(params){
      let row = params.data
      let colId = params.column.getId();
      switch (colId){
        case "studentName":
        case "studentEngName":
          this.$emit('showSelectStudentDialog', row)
          break;
        case "teacherName":
          this.$emit('showSelectTeacherDialog', row)
          break;
        case "sendFee":          //          event.rowIndex  / event.colDef.headerName
          this.$emit('updateSentFee', row)
          break;
        case "complete":          //          event.rowIndex  / event.colDef.headerName
          // row.assignStatus === 'ACTIVE' &&
          if ( row.assignCount <= (row.countAttended + row.countPostponed)) {
            return apiManager.completeAssign(row)
                .then(res => {
                  row.assignStatus = 'END'
                  const index = this.assignList.findIndex(v => v.assignId === res.assignId)
                  this.assignList.splice(index, 1, res)
                })
                .then(() => this.$dialog.notify.success('Update Successfully', {position: 'top-right', timeout: 1000}))
                .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
          }
          break;
        case 'countAttended':
        case 'wage':
        case 'assignStatus':
        case 'complete':
          break;
        default:
          this.$emit('showSelectAssignInfo', row)
          break;
      }
    },
    onCellValueChanged(params) {
      let row = params.data.student
      let colId = params.column.getId();
      switch (colId) {
        case "studentEngName":
          apiManager.setAccount(row)
              .then(res => row = res)
              .then(() => this.$dialog.notify.info('Success', {position: 'top-right', timeout: 1000}))
          break;
      }
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.$emit('onSelectionChanged', selectedRows)
    },
    removeRow(row){
      let selectedRows = this.gridApi.getSelectedRows();
      const removingRows = selectedRows.filter(v => v.assignId === row.assignId)
      this.gridApi.applyTransaction({ remove: removingRows })
    },
    hideActionColumn() {
      if(this.columnApi) {
        this.columnApi.setColumnVisible('id', !this.isMobile)
        this.columnApi.setColumnVisible('startDate', !this.isMobile)
        this.columnApi.setColumnVisible('classStartTime', !this.isMobile)
        this.columnApi.setColumnVisible('courseName', !this.isMobile)
        this.columnApi.setColumnVisible('skypeId', !this.isMobile)
        // this.columnApi.setColumnVisible('teacherName', !this.isMobile)
        this.columnApi.setColumnVisible('assignCount', !this.isMobile)
        this.columnApi.setColumnVisible('countCalculated', !this.isMobile)
        this.columnApi.setColumnVisible('courseName', !this.isMobile)

        this.columnApi.setColumnVisible('wage', !this.isMobile)
        this.columnApi.setColumnVisible('assignStatus', !this.isMobile)
        this.columnApi.setColumnVisible('attendFlag', !this.isMobile)
        this.columnApi.setColumnVisible('assignCount', !this.isMobile)
        this.columnApi.setColumnVisible('mention', !this.isMobile )

        this.columnApi.setColumnVisible('wage', this.isManager && !this.isMobile)
        this.columnApi.setColumnVisible('sendFee', this.isOwner )
        this.columnApi.setColumnVisible('complete', this.isManager && !this.isMobile)

        this.columnApi.setColumnVisible('status', !this.isOwner && !this.isMobile)
        this.columnApi.setColumnVisible('endDate', this.isOwner && !this.isMobile)
      }
    },
  }
}
</script>
